import {
  Button,
  Cascader,
  Form,
  message,
  Radio,
  Input,
  Select,
  Spin,
  Tabs,
  Tooltip,
} from 'antd'
import { Children, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { SEditor, SGeneralForms, SMessage, SSegmentedTabs } from 'shj-components'
import styles from '../../../index.module.less'
import DrawerToTab from '@/components/DrawerToTab'
import { isArray, uniqueId } from 'lodash-es'
import { EditOutlined } from '@ant-design/icons'
import { getDictServer } from '@/services/channelManagement'
import {
  getBrandList,
  getProductEnums,
  getunitList,
  getPackModelList,
  findProdCateTreeList,
  findServiceId,
  getSpecialCodesList,
} from '@/services/product'
import DragImageUpload from '@/components/Upload/dragImageUpload'
import PDFPreview from '@/components/PDFPreview'
import _, { isEmpty } from 'lodash'
import { useSetState } from 'ahooks'
import { getBizOpTypeEnum } from '@/services/customerServices'
import { useParams } from 'react-router-dom'
import { getParentId } from '@/utils/common.ts'
import { useStore, useAtomValue, useAtom, useSetAtom } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import {step1DataAtom, step2DataAtom, step3DataAtom, stepCommonDataAtom, stepOptionDataAtom} from '../store';
import ChooseDetailModal from './chooseDetailModal'

export default forwardRef(function Step1(props: any, ref: any) {
  const [formRef] = Form.useForm()
  const { id } = useParams() // 产品id
  const [openModal, setOpenModal] = useState(false);
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const [productChooseDetail, setProductChooseDetail] = useState({});
  const [state, setState] = useSetState<any>({
    prodCateList: [], // 产品分类枚举列表
    productTypeList: [], // 产品类型枚举列表
    demandList: [], // 需求标签枚举列表
    brandList: [], // 品牌枚举列表
    pmsSerList: [], // 产品服务枚举列表
    unitList: [], // 单位枚举列表
    packTypeTemplateList: [], // 打包模板列表
    specialCodeList: [], // 特项代码列表
  })
  const [step1Data, setStep1Data] = useAtom(step1DataAtom);
  const [step2Data, setStep2Data] = useAtom(step2DataAtom);
  const [stepCommonData, setStepCommonData] = useAtom(stepCommonDataAtom);
  const [stepOptionsData, setStepOptionsData] = useAtom(stepOptionDataAtom);
  const reset = useResetAtom(step2DataAtom)

  const prodType = Form.useWatch('prodType', formRef);
  const mainFiles = Form.useWatch('mainFiles', formRef);
  const attachList = Form.useWatch('attachList', formRef);
  const bizTag = Form.useWatch('bizTag', formRef);
  const packModelId = Form.useWatch('packModelId', formRef);
  const prodCateIdWatch = Form.useWatch('prodCateId', formRef);

  // 页面初始化
  useEffect(() => {
    setSpinLoading(true);
    getOptions()
  }, [])

  useEffect(() => {
    if (['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(prodType)) {
      getPackage(prodType);
    }
  }, [prodType])

  useEffect(() => {
    if (bizTag) {
      getPmsSerList(bizTag)
    }
  }, [bizTag])

  useEffect(() => {
    if (packModelId) {
      const packItem = state.packTypeTemplateList?.find(pack => pack.id === packModelId);
      if (!packItem) {
        return;
      }
      getArgs(packItem.specificationArgList);
      setStep1Data({
        ...step1Data,
        skuList: packItem.skuList ? [...packItem.skuList] : [],
        specificationArgList: packItem.specificationArgList ? [...packItem.specificationArgList] : [],
        treeNodes: packItem.treeNodes ? [...packItem.treeNodes] : [],
        priceItems: [],
        costTemplateId: ''
      });
      const {chooseTimeType} = packItem;
      setStepCommonData({
        ...stepCommonData,
        chooseTimeType,
      })
    } else {
      setStep1Data({
        ...step1Data,
        priceItems: [],
        costTemplateId: '',
      });
    }
  }, [packModelId])

  /**
   * 存在编辑回显接口和分类列表接口时序问题，要用两个Effect，接口调用顺序写的不好，都是并发了
   */
  useEffect(() => {
    const id = formRef?.getFieldValue('prodCateId')
    if (id && !Array.isArray(id) && state.prodCateList?.length) {
      const pathId = getParentId(state.prodCateList, id)
      formRef.setFieldsValue({
        prodCateId: pathId?.reverse(),
      })
    }
  }, [state.prodCateList])

  useEffect(() => {
    const id = formRef?.getFieldValue('prodCateId');
    if (id && !Array.isArray(id) && state.prodCateList?.length) {
      const pathId = getParentId(state.prodCateList, id)
      formRef.setFieldsValue({
        prodCateId: pathId?.reverse(),
      })
    }
  }, [prodCateIdWatch])

  useImperativeHandle(ref, () => {
    return {
      onSubmit,
      formRef,
      getInfo,
    }
  }, [step1Data])

  // 1.处理打包模板规格数据
  const getArgs = list => {
    const config = dataToForm(list || [], true);
    console.log(1)
    setStep2Data({
      ...step2Data,
      id,
      argsJsonList: [...list],
      config: [...config],
      notStandardConfig: [],
      skuList: [],
    })
  }

  // 参换转表单渲染
  const dataToForm = (list, isSpec = true) => {
    const newConfig: any = [{
      formItem: []
    }];

    list.forEach(item => {
      const isPackage = ['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(prodType)
      // 打包模板数据限制
      if (isPackage) {
        if (isSpec) {
          // 默认的数据不可编辑删除
          item.forBidDelete = true
          // 带出规格参数的值
          props.stepRef2?.current?.step2FormRef.setFieldValue(
            item.argCode,
            item.values?.length
              ? [...item.values?.map(item => item.valueId)]
              : undefined,
          )
        } else {
          // 新增的数据能删除编辑
          item.forBidDelete = false
          // 带出非规格参数的值
          props.stepRef2?.current?.step2UnFormRef.setFieldValue(
            item.argCode,
            item.values?.length
              ? [...item.values?.map(item => item.valueId)]
              : undefined,
          )
        }
      }

      const current = props.paramList.find(arg => arg.argCode === item.argCode) || {}

      newConfig[0].formItem.push({
        ...item,
        label: item.argName,
        name: item.argCode,
        spanCol: 24,
        required: item.argType === 'CHOOSE' ? true : false,
        options: current,
        type: item.argType,
      })
    })

    return newConfig;
  }

  const getPackage = async (prodType) => {
    const res = await getPackModelList({ enabled: true, prodType, queryTreeNodes: true, querySkus: true, filterEnableTreeNodes: true});
    setState({
      packTypeTemplateList: res || [],
    })
  }

  const getOptions = async () => {
    const res: any = await Promise.all([
      findProdCateTreeList({
        enabled: true,
        modeFlags: [4],
      }),
      getProductEnums('com.shj.saas.plus.product.enums.ProductTypeEnum'),
      getBizOpTypeEnum(),
      getunitList({ data: { enabled: true } }),
      getBrandList({ enabled: true }),
      getSpecialCodesList({ data: { enabled: true } }),
    ])
    const obj = {
      //所属分类数据
      prodCateList: [...res[0]],
      // 产品类型
      productTypeList: res[1].map((item: any) => {
        return { label: item.description, value: item.key }
      }),
      // 需求标签
      demandList: res[2].map((item: any) => {
        return { label: item.description, value: item.key }
      }),
      // 单位
      unitList: res[3],
      // 品牌
      brandList: res[4].map((item: any) => {
        return { label: item.name, value: item.id }
      }),
      specialCodeList: res[5].map((item: any) => {
        return { label: item.code + '-' + item.name, value: item.code }
      }),
    }
    //  初始化根据需求标签获取产品服务

    // 赋值初始化
    if (!id && !step1Data.id) {
      formRef.setFieldsValue({
        prodType: obj.productTypeList[0].value,
        bizTag: obj.demandList[0].value,
      })
    }
    setSpinLoading(false);
    setStepOptionsData({...stepOptionsData, specialCodeList: res[5]?.map((item: any) => {
        return { label: item.name + item.code, value: item.code }
      }) || []})
    setState({ ...obj })
  }

  const clickToDetail = (type = '', item: any) => {
    const descTypeList = attachList || [];

    if (!type) {
      // 新增
      if (descTypeList.length < 5) {
        setOpenModal(true);
        setProductChooseDetail({});
      } else {
        message.error('最多添加5个');
      }
    } else {
      setOpenModal(true);
      setProductChooseDetail({ ...item });
    }
  }

  const clickToChooseDetail = () => {
    setOpenDetailModal(true);
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
        const filterData = attachList.filter(item => item['key'] !== id)
        formRef.setFieldValue('attachList', [...filterData]);
        getInfo(filterData)
      },
    })
  }
  const onEditTab = (targetKey, action: 'add' | 'remove') => {
    if (action === 'remove') {
      onDel(targetKey)
    }
  }
  const onCloseDescModal = () => {
    setOpenModal(false);
    setProductChooseDetail({});
  }
  //   抽屉确认
  const onSaveDesc = values => {
    return new Promise(resolve => {
      let newData: any = attachList || []
      if (isEmpty(productChooseDetail)) {
        newData = [...newData, { ...values, key: _.uniqueId() }]
      } else {
        newData = newData.map(item => {
          if (item.key === productChooseDetail.key) {
            return { ...values, key: productChooseDetail.key }
          } else {
            return item
          }
        })
      }
      getInfo(newData)
      onCloseDescModal()
      resolve(true)
    })
  }
  // 将drawer组件的数据转为tabs显示的数据
  const getInfo = (descType: any[]) => {
    const data = descType.map(item => ({
      ...item,
      label: (
        <div>
          <span>{item.name}</span>
          <Tooltip title="编辑">
            <EditOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => clickToDetail(item.subBusType, item)}
            />
          </Tooltip>
        </div>
      ),
      children: getDetailType(item.subBusType, item),
      key: item.key,
    }))
    formRef.setFieldsValue({
      attachList: [...data],
    })
    return data
  }
  const getDetailType = (type: string, obj) => {
    const { attachPath = '', contentInfo } = obj
    const typeObj = {
      TYPE_TXT: (
        <SEditor
          readOnly
          init={{ toolbar: false, menubar: false, plugins: [] }}
          value={contentInfo}
        />
      ),
      TYPE_PDF: <PDFPreview url={attachPath} key={_.uniqueId()} />,
      TYPE_VIDEO: <video src={attachPath} controls={true} />,
      TYPE_DESIGN: (
        <Button
          type="link"
          onClick={() => {
            openNewWindow(attachPath)
          }}
        >
          {attachPath}
        </Button>
      ),
    }
    return typeObj[type]
  }
  const openNewWindow = (url: string) => {
    if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
      window.open(url)
    } else {
      window.open('http://' + url)
    }
  }
  // 提交数据
  const onSubmit = () => {
    formRef.setFieldValue('contactManage', step1Data.combinationInfo);
    return new Promise((resolve, reject) => {
      formRef
        ?.validateFields()
        .then(values => {
          const data = values
          data.attachList = attachsHandle(data.attachList, 'attachList');
          data.mainFiles = attachsHandle(data.mainFiles, 'mainPic');
          data.imageUrls = data.mainFiles.map(file => file.url || file.attachPath || file.response?.data?.fileUrl || file.urlSite || '')
          console.log(data.imageUrls)
          // 数据处理:
          if (data.prodCateId && isArray(data.prodCateId)) {
            data.prodCateId = data.prodCateId[data.prodCateId.length - 1];
          }
          data.packModelId = data.packModelId || '';
          setStep1Data({ ...step1Data, ...data });
          resolve({});
        })
        .catch(err => {
          reject(err)
        })
      })
  }
  // 附件信息处理
  const attachsHandle = (data: any, type: string) => {
    if (!Array.isArray(data)) return []
    return data.map(item => {
      // 根据主图或者产品详情信息区分字段数据
      if (type === 'mainPic') {
        item.isMainPic = true
        item.contentType = 'attachPic'
      } else {
        item.isMainPic = false
        switch (item.subBusType) {
          case 'TYPE_TXT':
            item.contentType = 'attachContent'
            break
          case 'TYPE_PDF':
            item.contentType = 'attachPDF'
            break
          case 'TYPE_VIDEO':
            item.contentType = 'attachVideo'
            break
          case 'TYPE_DESIGN':
            item.contentType = 'attachURL'
            break
          default:
            item.contentType = ''
            break
        }
      }
      return {
        ...item,
        attachName: item.attachName ? item.attachName : item.name,
        attachPath: item.attachPath
          ? item.attachPath
          : item.response?.data?.fileUrl || item.urlSite || '',
        content: item.contentInfo,
      }
    })
  }
  // 需求标签查产品服务
  const onBizTagChange = ({ target }) => {
    const e = target.value
    formRef?.setFieldsValue({
      bizTag: e,
      prodType: state.productTypeList[0].value,
      pmsSerId: undefined,
    })
  }
  const getPmsSerList = bizTagValue => {
    if (bizTagValue) {
      findServiceId({
        prodLabCodes: [bizTagValue],
        enabled: true,
      }).then(res => {
        // 产品服务
        const pmsSerList = res?.map((item: any) => {
          return { label: item.name, value: item.id }
        })
        setState({ pmsSerList })
      })
    }
  }
  const saveCombineData = data => {
    setStep1Data({
      ...step1Data,
      combinationInfo: data
    })
  }
  const specialCodeChange = (value: any, selectedOptions: any) => {
    // if (id) {
    //   return;
    // }
    formRef.setFieldsValue({
      specialCode: selectedOptions[selectedOptions?.length - 1]?.specialCode,
    })
  } 
  return (
    <div className={styles.stepBox}>
      <Spin spinning={spinLoading}>
        <Form
          form={formRef}
          layout={'vertical'}
          initialValues={{
            mainFiles: []
          }}
        >
          <Form.Item
            label={'所属分类'}
            name={'prodCateId'}
            rules={[{ required: true }]}
          >
            <Cascader
              options={state.prodCateList}
              placeholder="请选择分类"
              fieldNames={{
                value: 'id',
                label: 'cateName',
              }}
              style={{ maxWidth: 460 }}
              onChange={specialCodeChange}
              // disabled={Boolean(id && step1Data.sourceType !== 'SELF')}
            />
          </Form.Item>
          <Form.Item
            label={'需求标签'}
            name={'bizTag'}
            rules={[{ required: true }]}
          >
            <Radio.Group
              disabled={id}
              options={state.demandList}
              style={{ padding: 0 }}
              onChange={onBizTagChange}
            />
          </Form.Item>
          <Form.Item
            label={'产品类型'}
            name={'prodType'}
            rules={[{ required: true }]}
          >
            <Radio.Group
              disabled={id}
              options={
                bizTag !== 'productTypeRetail'
                ? state.productTypeList?.filter((item: any) => ['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(item.value))
                : state.productTypeList
              }
              style={{ padding: 0 }}
              onChange={({ target }) => {
                reset();
                const e = target.value
                formRef.setFieldValue('packModelId', '')
                formRef?.setFieldsValue({
                  prodType: e,
                })
              }}
            />
          </Form.Item>
          {
            prodType === 'PRODUCT_PACKAGE' || prodType === 'PRODUCT_DETAILS' ? (
              <Form.Item
                label={'打包模板'}
                name={'packModelId'}
                rules={[{ required: true }]}
              >
                <Select
                  disabled={id}
                  showArrow
                  showSearch
                  placeholder="请选择打包模板"
                  defaultActiveFirstOption={true}
                  notFoundContent={null}
                  options={state.packTypeTemplateList}
                  style={{ maxWidth: 460 }}
                  fieldNames={{ value: 'id', label: 'modelName' }}
                  filterOption={(input, option: any) => {
                    return option.modelName.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }}
                />
              </Form.Item>
            ) : null
          }
          <Form.Item
            label={'产品名称'}
            name={'prodName'}
            rules={[{ required: true }]}
          >
            <Input
              style={{ width: 460 }}
              placeholder='请输入产品名称'
              allowClear
              showCount
              maxLength={200}
            />
          </Form.Item>
          <Form.Item
            label={'产品服务'}
            name={'pmsSerId'}
          >
            <Select
              showArrow
              showSearch
              placeholder="请选择服务"
              defaultActiveFirstOption={true}
              allowClear
              style={{ maxWidth: 460 }}
              notFoundContent={null}
              options={state.pmsSerList}
              filterOption={(input, option: any) => {
                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
            />
          </Form.Item>
          <Form.Item
            label={'特项代码'}
            name={'specialCode'}
          >
            <Select
              showArrow
              allowClear
              showSearch
              optionFilterProp="label"
              placeholder="请选择特项代码"
              defaultActiveFirstOption={true}
              style={{ maxWidth: 460 }}
              options={state.specialCodeList}
            />
          </Form.Item>
          <Form.Item
            label={'单位'}
            name={['unitInfo', 'unitCode']}
            rules={[{ required: true }]}
          >
            <Select
              showArrow
              showSearch
              optionFilterProp="name"
              placeholder="请选择单位"
              defaultActiveFirstOption={true}
              style={{ maxWidth: 460 }}
              options={state.unitList}
              fieldNames={{ value: 'code', label: 'name' }}
              disabled={Boolean(id && step1Data.sourceType !== 'SELF')}
            />
          </Form.Item>
          <Form.Item
            label={'品牌'}
            name={'brandId'}
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              placeholder="请选择品牌"
              defaultActiveFirstOption={true}
              style={{ maxWidth: 460 }}
              notFoundContent={null}
              options={state.brandList}
              allowClear
              filterOption={(input, option: any) => {
                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
              disabled={Boolean(id && step1Data.sourceType !== 'SELF')}
            />
          </Form.Item>
          <Form.Item
            label={'产品主图'}
            name={'mainFiles'}
            rules={[{ required: true }]}
          >
            <DragImageUpload
              fileList={mainFiles || []}
              onChange={val => formRef.setFieldValue('mainFiles', val)}
              limit={5}
              accept={'.jpg,.jpeg,.png,.BMP'}
              multiple={true}
              // url={baseURL + `/file-web/fileStore/upload`}
              toolTip={'支持图片格式：JPEG/PNG/BMP，大小不超过10M，最多5张，建议比例4:3'}
            />
          </Form.Item>
          <Form.Item
            label={'产品详情'}
            name={'attachList'}
          >
            <>
              <Button type="primary" onClick={() => clickToDetail()}>
                添加
              </Button>
              {attachList?.length ? (
                <Tabs
                  style={{ marginTop: 10 }}
                  items={attachList}
                  type="editable-card"
                  onEdit={onEditTab}
                  hideAdd
                />
              ) : null}
            </>
          </Form.Item>
        </Form>
        {
          openModal && (
            <DrawerToTab
              record={productChooseDetail}
              open={openModal}
              onCancel={onCloseDescModal}
              title={`${productChooseDetail?.id || productChooseDetail?.key ? '编辑' : '新增'}产品详情`}
              onConfirm={onSaveDesc}
            ></DrawerToTab>
          )
        }
        {
          openDetailModal && (
            <ChooseDetailModal data={step1Data.combinationInfo} idList={step1Data.combinationInfo?.map(item => item.id) || []} save={saveCombineData} open={openDetailModal} onCancel={() => setOpenDetailModal(false)} title={'添加组合明细'} onConfirm={() => {}} />
          )
        }
      </Spin>
    </div>
  )
})
